import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { environment } from '../environments/environment';
import { AkitaNgDevtools } from '@datorama/akita-ngdevtools';
import { AkitaNgRouterStoreModule } from '@datorama/akita-ng-router-store';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { CustomButtonComponent } from './custom-controls/custom-button/custom-button.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Utility, Environment, CoreModule, Globals } from '@transfora/core';
import { AuthenticationModule, TokenInterceptor, AuthUserService } from '@transfora/authentication';
import { SharedModule, UserService, UserQuery } from '@transfora/admin';
import { LayoutComponent } from './layout/layout.component';
import { NoPrivilegeComponent } from './no-privilege/no-privilege.component';

@NgModule({
  declarations: [AppComponent, LayoutComponent, CustomButtonComponent, NoPrivilegeComponent],
  imports: [
    ...(environment.production ? [] : [AkitaNgDevtools.forRoot(), AkitaNgRouterStoreModule.forRoot()]),
    BrowserModule,
    BrowserAnimationsModule,
    AuthenticationModule,
    AppRoutingModule,
    CoreModule,
    SharedModule
  ],
  providers: [
    Globals,
    Utility,
    { provide: Environment, useValue: environment },
    { provide: 'api_url', useValue: environment.apiUrl },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: AuthUserService, useExisting: UserService },
    { provide: 'user_query', useClass: UserQuery }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  // From v9 Dynamic component which are not referenced directly in the project will be removed while tree shaking
  // Workaround for the above, just referencing
  static entryComponents = [
    // RegisterDynamicComponent Decorator Components
    CustomButtonComponent
  ];
}
